import { render } from "./ProfileOrderTable.vue?vue&type=template&id=7d0b311e"
import script from "./ProfileOrderTable.vue?vue&type=script&lang=js"
export * from "./ProfileOrderTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__